module.exports = __webpack_public_path__ + "static/media/voltgoathorn.2688be43.webp";